import { useEffect, useRef, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import styled from 'styled-components';
import SwipeableViews from 'react-swipeable-views';
import HOC from '../../HOC';
import { __ } from '../../../locales';
import LinkButton from '../../../common/LinkButton';
import BodyText from '../../../common/BodyText';
import { syncState } from '../../../helpers/iframeHelper';
import { saveInteraction } from '../../../helpers/gamification';
import { trackEvent } from '../../../helpers/common';
import events from '../../../app/events';
import ProgressIndicator from '../../../common/ProgresIndicator';
import CustomButton from '../../../common/CustomButton';

const Image = styled.div`
  background-image: url("${({ src }) => src}");
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  width: 300px;
  height: 300px;
  margin: 0 auto 20px;
`;

const Title = styled.h3`
  margin-bottom: 5px;
`;

const Header = styled.p`
  margin-bottom: 20px;
`;

const Body = styled.p`
  margin-bottom: 30px;
`;

const Container = styled.div`
  width: 82%;
  padding: 20px;
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
  background-color: white;
  margin-top: 10px;
  margin-right: auto;
  margin-left: auto;
  border-radius: 4px;
  padding-bottom: 20px;
`;

const MUM = ({
  discoveryData,
  updateDiscoveryData,
  setHeaderState,
  viewedEducationData
}) => {
  const { oidx } = useParams();
  const { push, go } = useHistory();
  const { misundestoodMaterials = [] } = discoveryData;
  const allMisundestoodMaterials = Object.values(misundestoodMaterials) || null;
  const viewedMuisunderstoodMaterials = viewedEducationData
    ?.misundestoodMaterials || [];
  const sortedMM = allMisundestoodMaterials
    .sort((a, b) => viewedMuisunderstoodMaterials.includes(a?.id)
      - viewedMuisunderstoodMaterials.includes(b?.id));
  const [swipeIndex, setSwipeIndex] = useState(sortedMM.findIndex((i) => i.id === +oidx));
  const matData = sortedMM[swipeIndex] || null;
  const windowRef = useRef(window);

  useEffect(() => {
    if (matData) {
      const newData = misundestoodMaterials[matData.id];
      newData.done = true;
      updateDiscoveryData({
        ...discoveryData,
        misundestoodMaterials: {
          ...misundestoodMaterials,
          [matData.id]: newData
        }
      });
      saveInteraction({
        type: 'MM',
        state: matData.id
      });
      syncState();
      windowRef.current.scrollTo(0, 0);
    }

    if (matData && matData.id) {
      trackEvent(events.DZ_MM_LAND, {
        mat_id: matData.id,
        mat_oidx: matData.oidx,
        mat_last: matData.isLastItem
      });
      setHeaderState({
        mat_id: matData.id,
        mat_oidx: matData.oidx,
        mat_last: matData.isLastItem
      });
    }
  }, [swipeIndex]);

  const onPrev = () => {
    trackEvent('DZ_MM_BACK_BTN_TAP');
    windowRef.current.scrollTo(0, 0);
    go(-1);
  };

  const getCertified = () => {
    const newData = misundestoodMaterials[matData.id];
    newData.done = true;
    updateDiscoveryData({
      ...discoveryData,
      misundestoodMaterials: {
        ...misundestoodMaterials,
        [matData.id]: newData
      }
    });
    saveInteraction({
      type: 'MM',
      state: matData.id
    });
    syncState();
    windowRef.current.scrollTo(0, 0);
    trackEvent(events.DZ_MM_GET_CERTIFIED_BTN_TAP);
    push('/quiz/mum/0');
  };

  if (!matData) return null;

  return (
    <div>
      <SwipeableViews
        index={swipeIndex}
        onChangeIndex={(i) => {
          setSwipeIndex(+i);
        }}
        enableMouseEvents
        animateHeight={sortedMM.length !== swipeIndex + 1}
      >
        {sortedMM.map((item) => (
          <div style={{ paddingBottom: '25px' }}>
            <Container>
              <Image src={item.image.replace(/ +/g, '%20')} />
              <Title>{item.title}</Title>
              <Header>{item.header}</Header>
              <BodyText>
                <Body
                  dangerouslySetInnerHTML={{
                    __html: item.body
                  }}
                />
              </BodyText>
              {sortedMM.length === swipeIndex + 1 ? (
                <div>
                  <CustomButton style={{ marginBottom: '20px' }} className="btn outline royal" onClick={getCertified}>
                    {__('app.get_certified')}
                  </CustomButton>
                  <LinkButton onClick={onPrev}>
                    {__('app.back')}
                  </LinkButton>
                </div>
              ) : null}
            </Container>
          </div>

        ))}
      </SwipeableViews>
      {
        sortedMM.length !== swipeIndex + 1
          ? (
            <ProgressIndicator
              data={sortedMM}
              index={swipeIndex}
              setIndex={setSwipeIndex}
              accessibilityLabel="Misunderstood Materials"
            />
          ) : null

      }
    </div>
  );
};

export default HOC(MUM);
